import { Theme } from '@material-ui/core';

const styles = (theme: Theme) => ({
  root: {
    display: 'flex',
  },
  drawerPaper: {
    backgroundColor: theme.palette.common.backgroundMuted,
  },
  notificationTitle: {
    // TODO: theme.typography.fontFamilySerif is undefined at runtime — likely intended to be variables.font.fontFamilySerif.join(',')
    // @ts-expect-error -- custom theme property not in MUI's Typography type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    fontFamily: theme.typography.fontFamilySerif,
    [theme.breakpoints.down('sm')]: {
      fontSize: 26,
    },
  },
  notificationsText: {
    border: `1px solid ${theme.palette.common.backgroundDark}`,
    padding: 20,
    fontFamily: theme.typography.fontFamily,
    marginBottom: 25,
    fontSize: 12,
    textTransform: 'uppercase',
  },
  notificationDivider: {
    backgroundColor: theme.palette.common.backgroundDark,
  },
  notificationIconContainer: {
    position: 'relative',
    width: 45,
    cursor: 'pointer',
  },
  notificationsMenu: {
    width: '40vw',
    overflowX: 'hidden',
    [theme.breakpoints.down('md')]: {
      width: '50vw',
    },
    [theme.breakpoints.down('xs')]: {
      width: '70vw',
    },
    '& .notificationsListItem': {
      border: `1px solid ${theme.palette.common.backgroundNotification}`,
      padding: 0,
    },
    '& .notificationread': {
      backgroundColor: theme.palette.common.backgroundDark,
    },
    '& .notificationunread': {
      backgroundColor: theme.palette.common.backgroundNotification,
    },
    '& .disabled': {
      opacity: '0.5',
      pointerEvents: 'none',
    },
  },
  openLink: {
    color: theme.palette.common.tan,
  },
  notificationClose: {
    marginLeft: 'auto',
    cursor: 'pointer',
  },
  arrowIcon: {
    height: 17,
    marginLeft: 5,
  },
});

export default styles;
